import React from "react";
import track from "react-tracking";

import Baselines from "../components/Baseline/BaselineMain";

const Baseline_Page = () => {
	return (
		<>
			{/* BaselineMain has pageMode="edit" by default 
			- access controle will be managed by user roles */}
			<Baselines />
		</>
	);
};

export const Baseline = track(
	{ page: "Baseline" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) },
)(Baseline_Page);
